module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_green.d3c67438.png";